import { CustomQueryModel } from './../models/custom-query.model';

export type CustomQueryState = CustomQueryModel[];

export const initialState: CustomQueryState = [] as CustomQueryState;
